import React, { useState } from 'react';

interface Props {
  label: string;
  onChange?: (value: number) => void;
}

const RangeSlider: React.FC<Props> = ({ label, onChange }) => {
  const [value, setValue] = useState<string>('0');
  return (
    <div>
      <label>{label}</label>
      <div className="flex justify-between mt-1.5">
        <input
          type="range"
          min="0"
          max="100"
          step="5"
          value={value}
          style={{ width: '80%' }}
          onChange={(event) => setValue(event.target.value)}
          onMouseUp={() => onChange?.(parseInt(value))}
        />
        <div>{value}%</div>
      </div>
    </div>
  );
};

export default RangeSlider;
